import assetPath from '../utils/assetPath';

const partners = [
  {
    id: 'f16-atom',
    name: 'F16 ATOM',
    desc: {
      en: 'Outdoor CQB field that hosts night sessions and partner events.',
      fr: 'Terrain CQB extérieur qui accueille des sessions de nuit et des événements partenaires.',
    },
    url: 'https://www.facebook.com/p/F16-ATOM-922-100090054549139/',
    logo: assetPath('/assets/partner-f16-atom.jpg'),
  },
  {
    id: 'ops-store',
    name: 'OPS Store',
    desc: {
      en: 'Specialized airsoft shop for outfitting kits and handling last-minute fixes.',
      fr: 'Boutique spécialisée qui équipe l’équipe et gère les ajustements de dernière minute.',
    },
    url: 'https://www.ops-store.fr/',
    logo: assetPath('/assets/logo-ops-store.jpg'),
  },
];

export default partners;
